<template>
  <div class="ke-card" :style="width ? { width: width + 'px' } : {}">
    <div class="ke-card-img" :style="imgHeight ? { height: imgHeight + 'px' } : {}">
      <img :src="imgSrc" alt="img" />
    </div>
    <div v-if="summary" class="ke-card-summary">{{ summary }}</div>
    <div v-else class="ke-card-summary">
      <slot></slot>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
export default {
  name: "ke-card",
  props: {
    width: {
      // 卡片宽度
      type: Number,
      default: 0,
    },
    imgSrc: {
      // 卡片图片资源地址
      type: String,
      default: "",
    },
    imgHeight: {
      // 卡片图片的宽度
      type: Number,
      default: 0,
    },
    summary: {
      // 卡片的概要
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>

</style>